var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("administration.company_edit") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-row",
            { staticClass: "pb-3 no-gutters" },
            [_c("back-button", { attrs: { returnUrl: _vm.returnUrl } })],
            1
          ),
          _vm._v(" "),
          _vm.activateSpinner ? _c("spinner") : _vm._e(),
          _vm._v(" "),
          _vm.activateSpinner === false
            ? _c(
                "form-accordion",
                {
                  attrs: {
                    isTitleUpperCase: false,
                    title: _vm.$t("common.busnss"),
                  },
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: {
                              isMandatory: "",
                              inputLabel: _vm.$t("administration.company_id"),
                              placeholderValue: _vm.CompaniesList[0].identifier,
                            },
                            model: {
                              value: _vm.identifier,
                              callback: function ($$v) {
                                _vm.identifier = $$v
                              },
                              expression: "identifier",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: {
                              isMandatory: "",
                              inputLabel: _vm.$t("administration.name"),
                              placeholderValue: _vm.CompaniesList[0].name,
                            },
                            model: {
                              value: _vm.name,
                              callback: function ($$v) {
                                _vm.name = $$v
                              },
                              expression: "name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c(
                            "form-write-group-label-input",
                            {
                              attrs: {
                                isMandatory: "",
                                inputType: "listeSelect",
                                inputLabel: _vm.$t(
                                  "administration.active_enable"
                                ),
                                placeholderValue: _vm.CompaniesList[0].active,
                              },
                            },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.active,
                                      expression: "active",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { id: "sel4" },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.active = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "0" } }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("administration.no")) +
                                        " "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "1" } }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("administration.in_prgrss")
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "2" } }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("administration.yes")) +
                                        " "
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: {
                              isMandatory: "",
                              inputLabel: _vm.$t(
                                "administration.company_email"
                              ),
                              placeholderValue:
                                _vm.CompaniesList[0].email_reference,
                            },
                            model: {
                              value: _vm.email_reference,
                              callback: function ($$v) {
                                _vm.email_reference = $$v
                              },
                              expression: "email_reference",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.canCompanyEdit
                    ? _c(
                        "b-row",
                        {
                          staticClass:
                            "justify-content-end form-group no-gutters",
                        },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeCompany()
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "fa-light fa-save" }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("common.sve"))),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _vm.activateSpinner === false
            ? _c(
                "form-accordion",
                {
                  attrs: {
                    isTitleUpperCase: false,
                    title: _vm.$t("administration.company_users"),
                  },
                },
                [
                  _vm.CompaniesList.length > 0
                    ? _c("b-table", {
                        attrs: {
                          hover: "",
                          fields: _vm.userFields,
                          items: _vm.CompaniesList[0].users,
                          selectable: _vm.CompaniesList[0].users.length > 0,
                          "empty-text": "Pas de résultat",
                        },
                        on: { "row-selected": _vm.seeUserDetails },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "cell(edit)",
                              fn: function (data) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-center d-inline-block py-3 w-100",
                                      on: {
                                        click: function ($event) {
                                          return _vm.activateUserEdit(
                                            $event,
                                            data.value
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-light fa-pencil",
                                      }),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "cell(delete)",
                              fn: function (data) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-center d-inline-block py-3 w-100",
                                      on: {
                                        click: function ($event) {
                                          return _vm.activateUserDelete(
                                            $event,
                                            data.value
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-light fa-trash",
                                      }),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3771373416
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.canAddUser
                    ? _c(
                        "b-row",
                        { staticClass: "justify-content-end no-gutters" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: { click: _vm.addUser },
                            },
                            [
                              _c("i", { staticClass: "fa-light fa-plus" }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("administration.user_add"))
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _vm.activateSpinner === false
            ? _c(
                "form-accordion",
                {
                  attrs: {
                    isTitleUpperCase: false,
                    title: _vm.$t("administration.company_prfls"),
                  },
                },
                [
                  _vm.CompaniesList.length > 0
                    ? _c("b-table", {
                        key: _vm.resetProfileTable,
                        attrs: {
                          hover: "",
                          fields: _vm.profileFields,
                          items: _vm.CompaniesList[0].profiles,
                          selectable: _vm.CompaniesList[0].profiles.length > 0,
                          "empty-text": "Pas de résultat",
                        },
                        on: { "row-selected": _vm.seeProfileDetails },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "cell(edit)",
                              fn: function (data) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-center d-inline-block py-3 w-100",
                                      on: {
                                        click: function ($event) {
                                          return _vm.activateProfilEdit(
                                            $event,
                                            data.value
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-light fa-pencil",
                                      }),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "cell(delete)",
                              fn: function (data) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-center d-inline-block py-3 w-100",
                                      on: {
                                        click: function ($event) {
                                          return _vm.activateProfilDelete(
                                            $event,
                                            data.value
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-light fa-trash",
                                      }),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3177330408
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.canAddProfil
                    ? _c(
                        "b-row",
                        { staticClass: "justify-content-end no-gutters" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: { click: _vm.addProfil },
                            },
                            [
                              _c("i", { staticClass: "fa-light fa-plus" }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("administration.profile_add"))
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _vm.activateSpinner === false
            ? _c(
                "form-accordion",
                {
                  attrs: {
                    isTitleUpperCase: false,
                    title: _vm.$t("administration.company_rights"),
                  },
                },
                [
                  _vm.CompaniesList.length > 0
                    ? _c("b-table", {
                        key: _vm.resetProfileTable,
                        attrs: { items: _vm.rights, fields: _vm.rightsFields },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "cell(right)",
                              fn: function (data) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("rights.db_rights." + data.value)
                                      )
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(delete)",
                              fn: function (data) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-center d-inline-block py-3 w-100",
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteRight(
                                            $event,
                                            data.value
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-light fa-trash",
                                      }),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2634333
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.canAddRights
                    ? _c(
                        "b-row",
                        { staticClass: "justify-content-end no-gutters" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: { click: _vm.addRight },
                            },
                            [
                              _c("i", { staticClass: "fa-light fa-plus" }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("administration.right_add"))
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }